import Community from '../api/community';
import * as mutation from '../mutations/community';

const state = {
  notifications_updated_cnt: 0,
  subscription: {
    channels_max_page: 2,
    channels: [],
    latest_updated_cnt: 0,
    posts_max_page: 2,
    posts: [],
  },
};

const getters = {
  subscriptionUpdatedCnt: state => state.subscription.latest_updated_cnt,
  channels: state => state.subscription.channels,
  posts: state => state.subscription.posts,
};

const actions = {
  selectSubscribedChannels ({ commit }, { second, page }) { // 구독 채널
    if (page <= state.subscription.channels_max_page) {
      return Community.getSubscribeChannel(second, page).then(response => {
        commit(mutation.SELECT_SUBSCRIBED_CHANNELS, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  selectSubscribedPosts ({ commit }, { second, page }) { // 구독 채널의 포스트
    if (page <= state.subscription.posts_max_page) {
      return Community.getSubscribePost(second, page).then(response => {
        commit(mutation.SELECT_SUBSCRIBED_POSTS, response);
      }).catch(err => {
        console.error(err);
      });
    }
  },
  selectOrderedChannels () {
    return Community.getChannelEdit();
  },
  updateOrderedChannels (context, { subscribe_channels, unsubscribe_channels }) {
    return Community.postChannelEdit(subscribe_channels, unsubscribe_channels);
  }
};

const mutations = {
  [mutation.SELECT_SUBSCRIBED_CHANNELS] (state, response) {
    state.subscription.channels_max_page = response.max_page;
    response.req_page === 1 ? state.subscription.channels = response.data : state.subscription.channels.push(...response.data);
  },
  [mutation.SELECT_SUBSCRIBED_POSTS] (state, response) {
    state.subscription.posts_max_page = response.max_page;
    state.subscription.latest_updated_cnt = response.data.latest_update_cnt;
    response.req_page === 1 ? state.subscription.posts = response.data.posts : state.subscription.posts.push(...response.data.posts);
  },
  [mutation.TOGGLE_LIKE] (state, { idx, flag }) { // 커뮤니티에서 뮤테이션
    if (state.subscription.posts.length) {
      let target = state.subscription.posts.find(el => {
        return el.idx === idx;
      });
      if (typeof target !== 'undefined' && typeof flag === 'boolean') {
        target.likes = flag;
        flag ? target.like_cnt++ : target.like_cnt--;
      }
    }
  },
  [mutation.TOGGLE_BOOKMARK] (state, { idx, flag}) {
    if (state.subscription.posts.length) {
      let target = state.subscription.posts.find(el => {
        return el.idx === idx;
      });
      if (typeof target !== 'undefined' && typeof flag === 'boolean') {
        target.bookmarks = flag;
        flag ? target.bookmark_cnt++ : target.bookmark_cnt--;
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
